module.exports = __webpack_public_path__ + "img/136.03a683fa.jpg";